import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'

const { color } = tokens

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-family: ${tokens.typography.fontFamily.primary};

  label {
    display: block;
    margin-bottom: 8px;
    font-size: 14px;
    font-weight: 500;
    color: ${color.text.label};
  }
`

export const Text = styled.p`
  margin: 0;
  text-align: center;
  font-size: 14px;
  color: ${color.text.secondary};
`

// Etiqueta actual → nueva etiqueta → Mover, alineados por la base de los campos
export const MoveRow = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 16px;
`

export const Field = styled.div`
  flex: 1;
  min-width: 0;
`

export const Arrow = styled.div`
  display: flex;
  align-items: center;
  height: 40px;
`

export const Checking = styled.div`
  display: flex;
  justify-content: center;
  padding: 24px 0;
`
